import React from 'react';
import { Star, ChevronDown, ChevronUp } from 'lucide-react';
import { Badge } from '../ui/badge';
import { ProductCard } from '../products/ProductCard';
import { CATEGORY_ICONS, CATEGORY_COLORS } from './FamilyCard';

export const WeeklyOffersSection = ({
    offersByCategory,
    weeklyOffers,
    selectedCategory,
    showWeeklyOffers,
    onToggleShow,
    search,
}) => {
    if (offersByCategory.length === 0 || search) return null;

    return (
        <div className="mb-10" data-testid="catalogue-weekly-offers">
            <button
                onClick={onToggleShow}
                className="flex items-center gap-3 w-full group mb-6"
            >
                <div className="flex items-center gap-2 bg-amber-500/10 px-4 py-2 rounded-xl">
                    <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
                    <h2 className="font-heading text-xl font-bold text-amber-600">
                        Offres de la Semaine
                    </h2>
                    <Badge className="bg-amber-500 text-white ml-2">
                        {selectedCategory
                            ? offersByCategory.filter(c => c.category_id === selectedCategory).reduce((s, c) => s + (c.products?.length || 0), 0)
                            : weeklyOffers.length}
                    </Badge>
                </div>
                <div className="flex-1 h-px bg-amber-200"></div>
                {showWeeklyOffers ? (
                    <ChevronUp className="w-5 h-5 text-amber-500" />
                ) : (
                    <ChevronDown className="w-5 h-5 text-amber-500" />
                )}
            </button>

            {showWeeklyOffers && (
                <div className="space-y-8">
                    {offersByCategory
                        .filter(c => !selectedCategory || c.category_id === selectedCategory)
                        .map((categoryOffers) => (
                        <div key={categoryOffers.category_id} className="bg-amber-50/30 rounded-2xl p-4 border border-amber-200/30">
                            <div className="flex items-center gap-3 mb-4">
                                <div
                                    className="w-10 h-10 rounded-xl flex items-center justify-center text-xl"
                                    style={{ backgroundColor: `${CATEGORY_COLORS[categoryOffers.category_id] || '#D97706'}20` }}
                                >
                                    {CATEGORY_ICONS[categoryOffers.category_id] || '📦'}
                                </div>
                                <h3 className="font-heading text-lg font-bold text-jungle">
                                    Offres {categoryOffers.category_name}
                                </h3>
                                <Badge
                                    className="text-white rounded-full"
                                    style={{ backgroundColor: CATEGORY_COLORS[categoryOffers.category_id] || '#D97706' }}
                                >
                                    {categoryOffers.count} offre{categoryOffers.count > 1 ? 's' : ''}
                                </Badge>
                                <div className="flex-1 h-px bg-gradient-to-r from-gray-200 to-transparent"></div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                {categoryOffers.products.map((product) => (
                                    <div key={product.id} className="relative" data-testid={`catalogue-offer-${product.id}`}>
                                        <ProductCard product={product} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
